import { MOCK_SERVER_BASE_URLS } from "src/app/shared/constants/mock-server-base-url.constants";
import { environment } from "src/environments/environment";

export function getManagedBackendBaseUrls(): string[] {
  const baseUrls = [
    environment.apiUrl,
    environment.sessionApiUrl,
    environment.commonApiUrl,
    environment.alphaSatApiUrl,
  ].filter((baseUrl): baseUrl is string => !!baseUrl);

  if (!environment.mockServerApiEnabled) {
    return baseUrls;
  }

  return [
    ...baseUrls,
    MOCK_SERVER_BASE_URLS.api,
    MOCK_SERVER_BASE_URLS.session,
    MOCK_SERVER_BASE_URLS.common,
  ].filter((baseUrl): baseUrl is string => !!baseUrl);
}

export function isManagedBackendUrl(url: string): boolean {
  return getManagedBackendBaseUrls().some((baseUrl) => url.startsWith(baseUrl));
}
